import { render, staticRenderFns } from "./CadastroApi.vue?vue&type=template&id=0cf4e145"
import script from "./CadastroApi.vue?vue&type=script&lang=ts"
export * from "./CadastroApi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports